import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { villageConfig } from '../config/index';

export default function VillageManagement() {
  return <CRUDManager config={villageConfig} />;
}